import { Paper, Stack, Typography, useTheme } from '@mui/material'
import PropTypes from 'prop-types'
import { useResponsive } from '../hooks/useResponsive'
import { getEntityHeaderStyles } from '../styles/components/common.styles'

const ellipsis = { maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis' }

export function EntityHeader({ displayName, customer, site }) {
  const theme = useTheme()
  const styles = getEntityHeaderStyles(theme)
  const { isMobile } = useResponsive()

  // Long camel-cased names get breathing room on narrow screens
  const formattedDisplayName =
    isMobile && displayName.length > 15
      ? displayName.replace(/([A-Z])/g, ' $1').trim()
      : displayName

  return (
    <Paper elevation={0} sx={styles.container}>
      <Stack spacing={1} sx={{ width: '100%', overflow: 'hidden' }}>
        <Typography
          variant='h4'
          sx={{ ...styles.title, wordBreak: 'break-word', overflowWrap: 'break-word' }}
        >
          {formattedDisplayName}
        </Typography>
        <Typography variant='overline' sx={{ ...styles.eyebrow, ...ellipsis }}>
          {customer}
        </Typography>
        <Typography variant='overline' sx={{ ...styles.eyebrow, ...ellipsis }}>
          {site}
        </Typography>
      </Stack>
    </Paper>
  )
}

EntityHeader.propTypes = {
  displayName: PropTypes.string.isRequired,
  customer: PropTypes.string.isRequired,
  site: PropTypes.string.isRequired,
}
